<template>
  <div>
    <div class="bd-header bd-header_autovesti">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/autovesti/img/logo.png" alt="">
      </div>
    </div>
    <div class="bd-autov">
      <img src="/pages/autovesti/img/article1.jpg" alt="" class="bd-autov__img">
      <div class="bd-autov__category">Новинки</div>
      <div class="bd-autov__title">ПРЕДСТАВЛЕНА SKODA OCTAVIA В "КАК БЫ СПОРТИВНОЙ" ВЕРСИИ</div>
      <div class="bd-autov__p bd-autov__p_b">
        Пока поклонники марки Skoda пребывают в предвкушении
        выхода новой Octavia, чешский производитель не дает им скучать
        и предлагает более стильные и динамичные внешне версии текущего поколения модели.
      </div>
      <div class="bd-autov__p">Как лифтбек, так и универсал Skoda
          Octavia получили новый пакет Dynamic+, визуально роднящие
        стандартные веси модели с заряженными модификации RS.
        Основной внешний "декор" включает в себя соответствующую решетку
        радиатора в комплекте со сплиттером, диффузор,
        новые бампера, а также зеркала черного цвета в сочетании с дымчатым
        остеклением. </div>
      <img src="/pages/autovesti/img/article2.jpg" alt="" class="bd-autov__img">
      <div class="bd-autov__p">Основной внешний "декор" включает
        в себя соответствующую решетку радиатора в комплекте со
        сплиттером, диффузор, новые бампера, а также зеркала черного
        цвета в сочетании с дымчатым остеклением.</div>

      <div class="bd-autov__p">
        <buzzCode @ready="ready" :id="id"></buzzCode>
      </div>
      <div class="bd-autov__p">Внутри автомобилей пакет Dynamic+
        предусматривает наличие спортивных сидений,
        многофункционального спортивного же рулевого колеса и
        гармонирующей с наружными элементами черной обивкой потолка.</div>
      <img src="/pages/autovesti/img/article3.jpg" alt="" class="bd-autov__img">
      <div class="bd-autov__p">Линейка двигателей для такой версии
        Осtavia пошире той, что была предложена ранее для
        варианта  SportLine, однако моторы от RS-модификации
        она тоже не включает.</div>
      <div class="bd-autov__p">И, увы, эта новость не даст заскучать
        лишь нашим западным соседям, а нам появление Octavia с
        пакетом Dynamic+ "не грозит": по информации из российского
        представительства марки, на российском рынке эту модель вряд
        ли стоит ожидать по причине ее дороговизны.</div>

      <div class="bd-autov__footer">
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'autovesti',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_autovesti
      background-color #FFF
      & ^[1]__menu
        fill #999
      .bd-ht__logo
        width 50%
        height auto
        margin auto
        fill #ff0147
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-autov
    font-family "Open Sans", sans-serif
    text-align left
    &__img
      display block
      width calc(100% - 48px)
      height auto
      margin 20px 24px
    &__date
      padding 40px 0 20px 24px
      fontSize(10,10)
      color #ff0147
    &__category
      display inline-block
      margin-left 24px
      padding 10px 18px
      background-color #ff0147
      fontSize(10,10)
      font-weight 600
      text-transform uppercase
      color white
    &__title
      margin 0 24px
      padding 20px 0
      fontSize(18,27)
      font-weight 100
      text-transform uppercase
      color #000
      &_small-indent
        padding 20px 0
        fontSize(25,30)
        text-transform none
    &__p
      margin 0 24px
      padding-bottom 20px
      fontSize(18,24)
      color #565656
      &_b
        font-weight 600
    &__news
      &-el
        padding-bottom 20px
    &__footer
      padding 24px 24px 36px
      background-color #252525
      &-logo
        width 40%
        margin 0 auto 40px
        padding 10px 30% 30px
        border-bottom 1px solid #444
        fill #FFF
      &-text
        fontSize(16,24)
        color #555

</style>
